import { Circle } from '@chakra-ui/react'
import { Button, ChevronLeftIcon, Flex, StatusBadge } from 'components'
import { statusBadgeStyles } from 'components/StatusBadge'
import { startCase } from 'lodash-es'
import { generatePath, useNavigate } from 'react-router'
import { useBreakpoint } from 'utils'
import defaultImage from '../../../assets/event_tile.png'
import { getEventStatus, useEvent } from '../../../utils/eventUtils'
import { RoutePath } from '../../../utils/routing'
import EventBannerActionButtons from './EventBannerActionButtons'

interface Props {
  expanded?: boolean
}

export default function EventBannerHeroImage({ expanded }: Props) {
  const navigate = useNavigate()
  const { event, imageUrl } = useEvent()
  const breakpoint = useBreakpoint()
  const unrestrained = expanded || breakpoint < 2

  if (!event) return null

  const status = getEventStatus(event)

  return (
    <Flex
      bgImage={`url(${imageUrl || defaultImage})`}
      bgPos="center"
      bgSize="cover"
      borderRadius={{ base: 'none', lg: 'md' }}
      height={unrestrained ? '170px' : '70px'}
      position="relative"
      width={{ base: '100%', lg: unrestrained ? '282px' : '94px' }}
    >
      {unrestrained ? (
        <StatusBadge
          position="absolute"
          bottom={4}
          left={{ base: 4, lg: 'unset' }}
          right={{ base: 'unset', lg: 4 }}
          text={startCase(status)}
          iconVisible={status === 'live'}
        />
      ) : (
        <Circle
          position="absolute"
          bottom={2}
          right={2}
          size="10px"
          bg={statusBadgeStyles[startCase(status) as keyof typeof statusBadgeStyles]?.bg}
        />
      )}

      {breakpoint < 3 && (
        <>
          <Button
            leftIcon={<ChevronLeftIcon />}
            onClick={() =>
              navigate(generatePath(RoutePath.Events, { workspaceId: event.workspaceId }))
            }
            position="absolute"
            top={4}
            left={4}
          >
            All Events
          </Button>
          <EventBannerActionButtons position="absolute" top={4} right={4} />
        </>
      )}
    </Flex>
  )
}
